import { prefixObjectValues } from '../../utils';
const form = {
  shiftDiffType: 'shift-diff-type',
  numDayShifts: 'num-day-shifts',
  numEveShifts: 'num-eve-shifts',
  numNightShifts: 'num-night-shifts',
  numOfWeDayShifts: 'num-of-we-day-shifts',
  numOfWeEveShifts: 'num-of-we-eve-shifts',
  numOfWeNightShifts: 'num-of-we-night-shifts',
  numHolDayShifts: 'num-of-hol-day-shifts',
  numHolEveShifts: 'num-of-hol-eve-shifts',
  numHolNightShifts: 'num-of-hol-night-shifts',
  eveShiftRateDiff: 'eve-shift-rate-diff',
  nightShiftRateDiff: 'night-shift-rate-diff',
  weDayShiftRateDiff: 'we-day-shift-rate-diff',
  weEveShiftRateDiff: 'we-eve-shift-rate-diff',
  weNightShiftRateDiff: 'we-night-shift-rate-diff',
  holDayShiftRateDiff: 'hol-day-shift-rate-diff',
  holEveShiftRateDiff: 'hol-eve-shift-rate-diff',
  holNightShiftRateDiff: 'hol-night-shift-rate-diff',
};
export default prefixObjectValues(form, 'shift-details-form');
